// Module Name
export const name = 'payments';

export const typePayments = {
    GET_CARDS: `${name}/GET_CARDS`,
    GET_GROUP_SETTINGS: `${name}/GET_GROUP_SETTINGS`,
    PUT_GROUP_SETTINGS: `${name}/PUT_GROUP_SETTINGS`,
    CALL_SERVER: `${name}/CALL_SERVER`,
    SET_DEFAULT_CARD: `${name}/SET_DEFAULT_CARD`,
    UPDATE_CARD: `${name}/UPDATE_CARD`,
    DELETE_CARD: `${name}/DELETE_CARD`,
    GET_VOUCHERS: `${name}/GET_VOUCHERS`,
    CREATE_VOUCHER: `${name}/CREATE_VOUCHER`,
    UPDATE_VOUCHER: `${name}/UPDATE_VOUCHER`,
    DELETE_VOUCHER: `${name}/DELETE_VOUCHER`,
};
